"use client";

import { ErrorMessage } from "@hookform/error-message";
import { Dispatch, SetStateAction, useRef, useState } from "react";
import Barcode from "react-barcode";
import { BarcodeScanner } from "react-barcode-scanner";
import { UseFormReturn, useWatch } from "react-hook-form";
import sanitizeHtml from "sanitize-html";

import { useTranslation } from "../../core/translation.core";
import { FancyTextInput } from "../reuseables/form.comp";
import Modal from "../reuseables/modal.comp";

export default function ProductBarCodeEditor({ methods }: { methods: UseFormReturn<any, any> }) {
  const { t, msg } = useTranslation();
  const [startScanner, setStartScanner] = useState(false);

  const barcode = useWatch({ control: methods.control, name: "barcode" });

  return (
    <section className="border p-2">
      {startScanner ? <ScannerModal methods={methods} setStartScanner={setStartScanner} /> : null}
      <div>{barcode ? <Barcode value={barcode} /> : null}</div>
      <div className="flex items-center gap-2 mb-2">
        <div>
          {t(msg.scanner.enterValue)}
          <FancyTextInput type="text" register={() => methods.register("barcode")} placeholder="Bar Code" />
        </div>
      </div>
      <ErrorMessage
        name="barcode"
        errors={methods.formState.errors}
        render={({ message }) => (
          <div
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(message, { allowedAttributes: { "*": ["style", "href"] } }) }}
            className="text-red-400 text-xs"
          ></div>
        )}
      />
      <p className="mb-2">{t(msg.scanner.or)}</p>
      <button type="button" onClick={() => setStartScanner(true)} className="bg-her-blue text-white rounded-lg px-4 py-2">
        {t(msg.scanner.scanBarcode)}
      </button>
    </section>
  );
}

const ScannerModal = ({ methods, setStartScanner }: { methods: any; setStartScanner: Dispatch<SetStateAction<boolean>> }) => {
  const btnRef = useRef(null);

  return (
    <Modal setModalOpened={setStartScanner} btnRef={btnRef}>
      <BarcodeScanner
        onCapture={(barcode) => {
          setStartScanner(false);
          methods.setValue("barcode", barcode.rawValue);
        }}
        options={{
          formats: ["codabar", "qr_code", "ean_13", "ean_8", "itf", "unknown"],
        }}
      />
    </Modal>
  );
};
